import { WidgetProvider } from '@telescope/cassini-hooks';
import { AppProvider } from 'providers';
import { AppRoutes } from 'routes';

export const App = () => {
  return (
    <WidgetProvider pollingRate={5000}>
      <AppProvider>
        <AppRoutes />
      </AppProvider>
    </WidgetProvider>
  );
};
